import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import { insertBreadcrumb, tryParseJSON } from '../../utils/common';
import { generateHreflangLinks } from '../../utils/hreflangHelper';

import Layout from '../../layout/withModal';
import { render } from '../../components/render';
import ErrorPage from '../../components/ErrorPage';

import { getPage } from '../../redux/page/page.action';
import { pageGetData } from '../../redux/page/page.selector';
import { getGlobal } from '../../redux/global/global.action';
import { globalGetData, globalInit } from '../../redux/global/global.selector';
import { generateStructuredData } from '../../utils/structuredData';
import { getSEOIndexValues } from '../../utils/previewDomain';

// import { reformatGlobal } from '../../utils/formatData';

const IndexPage = props => {
    const { Global, Seo, Contents, breadcrumb, isErrorPage, pagePath, isPreviewDomain } = props;
    const firstCompType = Contents?.length ? Contents[0].type : isErrorPage ? 'error' : '';
    insertBreadcrumb(Contents, breadcrumb);
    const structuredData = generateStructuredData(pagePath, Seo, Global, breadcrumb, Contents);
    const structuredDataValid = structuredData && tryParseJSON(structuredData);
    const { noindex, nofollow } = getSEOIndexValues(isPreviewDomain, Seo);
    const hreflangLinks = generateHreflangLinks('news-and-insights/announcements');
    return (
        <Layout {...Global} firstCompType={firstCompType} googleMapKey={Global.googleMapKey}>
            <NextSeo
                title={Seo?.pageTitle}
                description={Seo?.pageDescription}
                canonical={Seo?.pageUrl}
                noindex={noindex}
                nofollow={nofollow}
            />
            <Head>
                <meta name='google-site-verification' content='Nd8hWdAqqvXuwbAn3xvEO9UOvXsnP-oauHB5gk2mro8' />
                <link rel='shortcut icon' href={Global.favicon.url} />
                <meta name='title' content={Seo?.pageTitle} />
                <meta name='keywords' content={Seo?.pageKeywords} />
                <meta name='thumbnail' content={Seo?.pageOgImage} />
                <meta property='og:url' content={Seo?.pageUrl} />
                <meta property='og:title' content={Seo?.pageOgTitle} />
                <meta property='og:description' content={Seo?.pageOgDescription} />
                <meta property='og:image' content={Seo?.pageOgImage} />
                {hreflangLinks.map(link => (
                    <link key={link.hrefLang} rel='alternate' hrefLang={link.hrefLang} href={link.href} />
                ))}
                {structuredDataValid && (
                    <script
                        type='application/ld+json'
                        dangerouslySetInnerHTML={{
                            __html: structuredData,
                        }}
                    ></script>
                )}
            </Head>
            {Contents && Contents.map((content, i) => render(content, i, Contents, true))}
            {isErrorPage && <ErrorPage />}
        </Layout>
    );
};

IndexPage.getInitialProps = async ctx => {
    const { query, res, req } = ctx;
    const { lang, preview, pageId } = query;
    const { dispatch, getState } = ctx.store;

    // Extract pagePath similar to [...pagepath] approach
    const pathname = req?.url ? req.url.split('?')[0] : '';
    const pagepath = pathname.split('/').filter(p => p);
    let pagePath = '';
    if (pagepath && pagepath.length > 0) {
        pagePath = pagepath.join('/');
    }

    let isErrorPage = false;
    await dispatch(getPage('/news-and-insights/announcements', lang, preview, pageId));
    const PageData = pageGetData(getState());
    if (res && !PageData.seo) {
        res.statusCode = 404;
        isErrorPage = true;
    }

    // global header, footer
    const isGlobalInit = globalInit(getState());

    if (!isGlobalInit || !globalGetData(getState()).data) {
        await dispatch(getGlobal(lang));
    }

    const GlobalData = globalGetData(getState());
    const Global = GlobalData.data;

    // const Global = reformatGlobal(PageData.Global, Globals, lang);
    const Seo = PageData.seo;
    const Contents = PageData.contents;
    const breadcrumb = PageData.breadcrumb;

    return {
        Global,
        Seo,
        Contents,
        breadcrumb,
        isErrorPage,
        pagePath,
    };
};

IndexPage.propTypes = {
    Global: PropTypes.object,
    Seo: PropTypes.object,
    Contents: PropTypes.array,
    breadcrumb: PropTypes.object,
    isErrorPage: PropTypes.bool,
    pagePath: PropTypes.string,
    isPreviewDomain: PropTypes.bool,
};

export default IndexPage;
